import { TaskTypes } from '../../../types/api/task'

export const CORRECTOR_APPROVAL_TASK_TYPE: TaskTypes = 'Подтверждение корректором'
